export default __webpack_public_path__ + "static/media/arrow-right-new-gradient.170216a0.svg";